// Typed wrappers around the /v1/conversations read endpoints. Mirrors
// lib/api/api-keys.ts in shape so the dashboard's mutation/query call sites
// look identical regardless of the resource being managed.

import type {
  ConversationListResponse,
  ConversationTrace,
} from '@cortex/shared';
import type { ApiClient } from '../api-client.js';

export const conversationsApi = {
  list: (api: ApiClient, limit?: number) =>
    api.get<ConversationListResponse>(
      limit !== undefined ? `/v1/conversations?limit=${String(limit)}` : '/v1/conversations',
    ),
  trace: (api: ApiClient, id: string) =>
    api.get<ConversationTrace>(`/v1/conversations/${id}`),
} as const;

export const CONVERSATIONS_QUERY_KEY = ['conversations'] as const;
export const conversationTraceQueryKey = (id: string) => ['conversation', id] as const;
